import { useEffect, useRef } from 'react'

/**
 * Hook para polling automático
 * @param callback Função a ser executada periodicamente
 * @param interval Intervalo em ms (padrão 5000)
 * @param enabled Se o polling está habilitado
 */
export function usePolling(
  callback: () => void | Promise<void>,
  interval: number = 5000,
  enabled: boolean = true
) {
  const savedCallback = useRef(callback)
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)

  // Atualiza a ref do callback quando muda
  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    // Limpa interval anterior
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }

    if (!enabled) return

    // Cria novo interval
    intervalRef.current = setInterval(() => {
      savedCallback.current()
    }, interval)

    // Cleanup
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
    }
  }, [interval, enabled])

  // Retorna função para parar manualmente
  return {
    stop: () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
    }
  }
}

export default usePolling
